import React, { useState, useEffect, useContext } from 'react';



import { FcKindle } from "react-icons/fc";

import Loader from '../../components/loader/loader';
import { numberFormatter, totalFormatter, decimalFormatter } from '../../components/formatters/numberFormatter';
import { dateFormatter } from '../../dynamic/dateFormatter';
import { typeFormatter, paymentTypeFormatter } from '../../components/formatters/defFormatter';
import { dateTableFormatter } from '../../dynamic/dateFormatter';
import toast from 'react-hot-toast';
import { FiRotateCcw } from "react-icons/fi";
import { Space, Input, Tag, Button, Spin, Modal, Card, Tabs } from 'antd';

import Select from 'react-select';
import AsyncSelect from 'react-select/async';

import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";

import { DataContext } from '../../init/getData';

import TrialBalance from './trialBalance/trialBalance';
import AccountStatement from './accountStatement/accountStatement';
import IncomeStatement from './incomeStatement/incomeStatement';
import CashFlow from './cashFlow/cashFlow';
import BalanceSheet from './balanceSheet/balanceSheet';
import TreeBalance from './treeBalance/treeBalance';

function FinancialReports(props) {

  let { type, isDebit } = props;

  const { api, userData, settingData, refProductData, devData, contentLanguages } = useContext(DataContext);
  const userRole = userData.role;
  const [loadingCounter, setLoadingCounter] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isSpinning, setIsSpinning] = useState(false);
  const [data, setData] = useState([]);
  const createdBy = parseInt(userData.id);
  const roundTo = settingData.roundTo;


  const items = [
    {
      key: '1',
      label: contentLanguages.TrialBalance,
      children: <TrialBalance/>
    },
    {
      key: '2',
      label: contentLanguages.AccountStatement,
      children: <AccountStatement/>
    },
    {
      key: '3',
      label: contentLanguages.BalanceSheet,
      children: <BalanceSheet/>
    },
    {
      key: '4',
      label: contentLanguages.CashFlow,
      children: <CashFlow/>
    },
    {
      key: '5',
      label: contentLanguages.IncomeStatement,
      children: <IncomeStatement/>
    },
    {
      key: '6',
      label: contentLanguages.BalanceByTree,
      children: <TreeBalance/>
    },
  ];



  return (

    <div style={{alignItems: 'center'}}>
      <Tabs defaultActiveKey="1" centered={true} items={items} destroyInactiveTabPane/>
    </div>

  )
}

export default FinancialReports;
